import {observable,action} from 'mobx';
import {ViewBase} from 'mutants-appfx';
import {FeedbackType} from './FeedBackConst';
import _isArray from 'lodash/isArray';
import _forOwn from 'lodash/forOwn';
import _filter from 'lodash/filter';
import {toJS} from 'mobx';
import {filterField} from '../fixedViewInfo';
import {Message,ModalWraper} from 'tplus-components-touch';

class FeedBackModal extends ViewBase {
    get type(){
      return 'FeedBackModal';
    }

    @observable visible = false;
    @observable formData;
    cancelable = false;
    title = '';
    content = '';
    dataSource = [];
    columns = [];
    modalType = '';
    feedbackType = '';
    okButtonTitle = '确定';

    constructor(store,name){
      super(store,name);
    }

    @action
    inputForm=({feedbackType = FeedbackType.Confirm,title,content = '提示内容',dataSource = [],columns = [],check},out)=>{
      this.title = title;
      this.content = content;
      this.dataSource = toJS(dataSource);
      this.columns = toJS(columns);
      this.out = out;
      this.check = check;
      this.tableWidth = 758;
      if(this._checkDetails()){
        this._handleColumn(columns);
        this._handleFeedbackType(feedbackType);
        this._handleModalType(dataSource);
        this.show();
      }
    }

    //检查传入的detail参数是否正确
    _checkDetails(){
      if(this.dataSource.length == 0){
        return true;
      }
      _forOwn(this.dataSource[0],(value,key)=>{
        if(_filter(this.columns, (column)=> {return key = column.dataIndex}).length === 0){
          console.warn(`column ${key} 未定义`);
          return false;
        }
      });
      return true;
    }

    //处理列 设置列宽
    _handleColumn(columns){
      if(columns && columns.length > 0){
        const fixedCount=1;//固定列数
        const columnLength = columns.length;
        let columnWidth;
        if(columnLength<=5){
          columnWidth=this.tableWidth/columnLength
        }else{
          columnWidth=150;
          columns.forEach((el,index)=>{
            if(index<fixedCount)el.fixed='left';
          })
        }
        columns.forEach((column)=>{
          column.width = columnWidth
        });
      }
    }

    _handleFeedbackType(feedbackType){

      //弹框是否有取消按钮
      this.feedbackType = feedbackType;
      switch(this.feedbackType)
      {
        case FeedbackType.Forbidden:
          this.title = !this.title?'禁止提示信息':this.title;
          this.okButtonTitle = '确定';
          this.cancelable = false;
          break;
        case FeedbackType.Confirm:
          this.title = !this.title?'确认提示信息':this.title;
          this.okButtonTitle = '继续';
          this.cancelable = true;
          break;
        case FeedbackType.PwdAuth:
          this.title = !this.title?'密码授权':this.title;
          this.okButtonTitle = '确定';
          this.formData = {
            Data: filterField('PwdAuth'),
          }
          this.cancelable = true;
          break;
        case FeedbackType.OtherAuth:
          this.title = !this.title?'其他用户授权':this.title;
          this.okButtonTitle = '确定';
          this.formData = {
            Data: filterField('OtherAuth'),
          }
          this.cancelable = true;
          break;
        default:
          break;
      }
    }


    //确定弹框类型
    _handleModalType(dataSource){
      if(!!dataSource && _isArray(dataSource)&&dataSource.length > 0){
        this.modalType = 'big';
      }else{
        this.modalType = 'mid';
      }

    }



    @action changeValue=(field,value)=>{
      field.Value=value;
    }

    @action
    okFun = async ()=>{
      if(this.check){
        let outData={};
        if(!!this.formData && !!this.formData.Data){
          this.formData.Data.forEach((el)=>{
            outData[el.FieldName]=el.Value;
          })
        }
        let checkResult = await this.check(outData);
        if(checkResult){
          if (checkResult.hasOwnProperty('Success')) {
            if (!checkResult.Success) {
              Message.warn(checkResult.ErrorMsg);
              return;
            }
          } else {
            Message.warn(checkResult);
            return;
          }
        }
        this.out(true);
        this.hide();
      }
    }

    // @action
    // error=(checkData)=>{
    //   let mainData=this.formData.Data;
    //   mainData.forEach((el)=>{
    //     el.State='';
    //     el.Label='';
    //   })
    //   let opeObj=mainData.find((field)=>field.FieldName===checkData.FieldName);
    //   if(!opeObj){
    //     console.warn('form校验 错误信息不正确');
    //     return;
    //   }
    //   opeObj.State=checkData.State;
    //   opeObj.Label=checkData.Label;
    // }

    @action
    ok=()=>{
      if(FeedbackType.Forbidden === this.feedbackType){
        //如果类型是禁止的话  点击确定后，直接回调cancel事件
        this.cancel();
        return;
      }
      this.okFun();
    }

    @action
    cancel=()=>{
        this.out(false);
        this.hide();
    }

    @action reset(){
      this.formData=null;
    }

    @action
    show=()=>{
        this.visible=true;
    }

    @action
    hide=()=>{
        this.visible=false;
        this.reset();
    }

    static fromJS(store, {TextBox:formData}) {
      return new FeedBackModal(store, 'FeedBackModal','')
    }

  }
  export default FeedBackModal;
